import Image from 'next/image';
import React from 'react';

import StyledCampaignDiscount, {
  StyledCampaignDiscountProps
} from './StyledCampaignDiscount';

export type CampaignDiscountProps = StyledCampaignDiscountProps & {
  campaignDiscountText: string;
  logo?: string;
};

const CampaignDiscount: React.FC<CampaignDiscountProps> = ({
  campaignDiscountText,
  logo,
  ...rest
}) => {
  return (
    <StyledCampaignDiscount {...rest}>
      {logo && (
        <Image
          src={logo}
          alt={campaignDiscountText}
          width={62}
          height={62}
          quality={100}
          style={{
            objectFit: 'contain'
          }}
        />
      )}
      {campaignDiscountText}
    </StyledCampaignDiscount>
  );
};

export default CampaignDiscount;
